import { decodeHTML } from 'entities';

const hasTags = (str: string) => str.includes('<');

export const removeHtmlTags = (title: string) => title.replace(/<\/?[a-z]{1,6}\s?\/?>/g, '');

export const makeSimple = (str: string) => {
  const text = decodeHTML(str);
  return hasTags(text) ? removeHtmlTags(text) : text;
};

export const getFullUrlPath = (path: string | undefined, envURL: string): string => {
  const fallbackEnvURL = 'https://www.very.co.uk';
  const normalizedApiURL = (envURL || fallbackEnvURL).replace(/\/+$/, '');
  // eslint-disable-next-line no-nested-ternary
  const normalizedPath = path ? (path.startsWith('/') ? path : `/${path}`) : '';
  return normalizedPath ? `${normalizedApiURL}${normalizedPath}` : normalizedApiURL;
};

const isWrongTail = (url: string) => url.charAt(url.length - 1) === '?';
const cutLastCharachter = (url: string) => url.substring(0, url.length - 1);

const hasParams = (url: string) => url.includes('?');

// to test it locally just set globalBrand to 'very'
const getRoundelUrlParams = (globalBrand: string, roundelId: string) => `$roundel_${globalBrand}$&p1_img=${roundelId}`;

export const addRoundel = (src: string, roundelId: string | undefined, globalBrand: string | undefined) => {
  if (!src || !roundelId || !globalBrand) {
    return src;
  }
  const url = isWrongTail(src) ? cutLastCharachter(src) : src;
  const params = getRoundelUrlParams(globalBrand, roundelId);

  return hasParams(url) ? `${url}&${params}` : `${url}?${params}`;
};

const char = '%\u0304%';
const charRegex = new RegExp(char, 'g');
const spaceRegex = / /g;
export const getEncodeId = (text: string) => text.replace(spaceRegex, char);
export const getDecodeId = (text: string) => text.replace(charRegex, ' ');
export const stringToChars = (text: string) => text.replace(/[^\w-]/g, '');

export const isIosSafari = () => {
  const ua = window?.navigator?.userAgent || '';
  const isIos = !!(
    /iP(hone|od|ad)/.test(ua) &&
    !!ua.match(' Safari/') &&
    !ua.match(' Chrom') &&
    !!ua.match(' Version/')
  );

  return isIos;
};

export const isIosApp = () => {
  const ua = window?.navigator?.userAgent || '';
  return /.*SDIPhoneApp.*/.test(ua);
};

export const formatReviewCount = (count: number) => {
  const reviewCount = count / 1000;
  const countcalc = reviewCount % 1 === 0 ? reviewCount : parseFloat(reviewCount.toFixed(1));
  const formattedCount = count && count >= 1000 ? `${countcalc}k` : count;
  return formattedCount;
};
